import { RouterProvider } from 'react-router-dom';
import { createRouter } from './router/create-router';
import { NotificationProvider } from '@features/notifications';

const router = createRouter();

export default function App() {
  return (
    <NotificationProvider>
      <RouterProvider router={router} />
    </NotificationProvider>
  );
}
